import { FuseConfig } from 'app/projects/fuse/src/lib/types/fuse-config';

/**
 * Default Fuse Configuration
 *
 * You can edit these options to change the default options. All these options also can be
 * changed per component basis. See `app/main/pages/authentication/login/login.component.ts`
 * constructor method to learn more about changing these options per component basis.
 */

export const fuseConfig: FuseConfig = {
    // Color themes can be defined in src/app/app.theme.scss
    colorTheme: 'theme-default',
    customScrollbars: true,
    layout: {
        style: 'horizontal-layout-1',
        width: 'fullwidth',
        navbar: {
            primaryBackground: 'maxbrain-500',
            secondaryBackground: 'maxbrain-700',
            folded: false,
            hidden: false,
            position: 'top',
            variant: 'vertical-style-2',
        },
        toolbar: {
            customBackgroundColor: false,
            background: 'fuse-white-500',
            hidden: false,
            position: 'above',
        },
        footer: {
            customBackgroundColor: true,
            background: 'maxbrain-700',
            hidden: false,
            position: 'below-fixed',
        },
        sidepanel: {
            hidden: true,
            position: 'right',
        },
    },
};
